import axios from 'axios';
import { saveBidMode } from '../../scenes/BidSession/helpers.js';
import * as actionTypes from './actionTypes';
import apiCall from '../app/apiCall';
import { LANGUAGE, LOADSTANDING_KEY } from './../constants';
import {buildUrlWithAdminImpersonation} from "../../utilities/helpers";

export const fetchSettingsRequest = () => ({
  type: actionTypes.FETCH_SETTINGS_REQUEST
});
export const fetchSettingsSuccess = settings => ({
  type: actionTypes.FETCH_SETTINGS_SUCCESS,
  settings
});
export const fetchSettingsFailure = error => ({
  type: actionTypes.FETCH_SETTINGS_FAILURE,
  error
});
export const updateBidModeSuccess = () => ({
  type: actionTypes.UPDATE_BIDMODE_SUCCESS,
});
export const updateBidModeFailure = error => ({
  type: actionTypes.UPDATE_BIDMODE_FAILURE,
  error
});

export function reloadSessionStorageUserInfo(userInfo) {
  const prevLanguage = sessionStorage.getItem(LANGUAGE.LANG_KEY);
  const prevLoadStanding = sessionStorage.getItem(LOADSTANDING_KEY);

  const newLanguage =
    userInfo.language && userInfo.language.code
      ? userInfo.language.code
      : LANGUAGE.DEFAULT_LANG;
  const newLoadStanding = JSON.stringify(userInfo.loadStanding) || null;

  sessionStorage.setItem(LANGUAGE.LANG_KEY, newLanguage);
  sessionStorage.setItem(LOADSTANDING_KEY, newLoadStanding);

  // This bring a regression, not sure of the purpose of it
  // if (
  //   (newLanguage && newLanguage !== prevLanguage) ||
  //   (newLoadStanding && newLoadStanding !== prevLoadStanding)
  // ) {
  //     window.location.hash = "/settings";
  // }
}

export function getUserInfo(staffId) {
  return () => {
    const userUrl = `profiles/${staffId}`;
    return apiCall(userUrl, 'get');
  };
}

export function saveUserInfo(checked, locale, staffId) {
  const data = {
    locale,
    staffId,
    checked
  };

  return () => {
    const saveUserInfoUrl = `profiles/${locale}/${staffId}/${checked}`;
    return apiCall(saveUserInfoUrl, 'put', data);
  };
}

export function fetchSettings(staffId, standingBidSessionId) {

  return (dispatch) => {
    dispatch(fetchSettingsRequest());
    const lang = 'fr';
    const lastRevisionUrl = `preferences/bid-session/${standingBidSessionId}/employee/${staffId}/last-revision`;
    const bidPreferencesUrl = buildUrlWithAdminImpersonation(`preferences/bid-session/${standingBidSessionId}/employee/${staffId}/${lang}`);
    axios
      .all([apiCall(lastRevisionUrl), apiCall(bidPreferencesUrl)])
      .then(
        axios.spread((lastRevisionResponse, bidPreferencesResponse) => {
          let lastRevisionDataResponse = {};
          if (typeof lastRevisionResponse.data === 'object') {
            lastRevisionDataResponse = lastRevisionResponse.data;
          }
          const lastRevisionData = lastRevisionDataResponse;
          const bidPreferencesData = bidPreferencesResponse.data;
          dispatch(
            fetchSettingsSuccess({
              lastRevisionData,
              bidPreferencesData
            })
          );
        })
      )
      .catch(error => dispatch(fetchSettingsFailure(error)));
  };
}

export function getLanguage(staffId) {
  return () => {
    const languageUrl = `profiles/${staffId}`;
    apiCall(languageUrl, 'get').then((response) => {
      reloadSessionStorageUserInfo(response.data);
    });
  };
}

export function openbid(categoryId) {
  return () => {
    const getOpenBidsUrl = 'preferences/bid-sessions/';
    const openBidsData = {
      categoryId
    };
    return apiCall(getOpenBidsUrl, 'post', openBidsData);
  };
}

export function updateWeightMode(preference, bidMode) {
  return () => {
    const baseUrl = `preferences/bids/weight/update/?bidMode=${bidMode}`;
    const url = buildUrlWithAdminImpersonation(baseUrl);

    return apiCall(url, 'put', preference);
  };
}

export function updateAllWeightMode(preference, bidMode) {
  return () => {
    const baseUrl = `preferences/bids/weight/update-all/?bidMode=${bidMode}`;
    const url = buildUrlWithAdminImpersonation(baseUrl);

    return apiCall(url, 'put', preference);
  };
}

export function updateBidSessionBidMode(preference, bidMode) {
  return (dispatch) => {
    const bidModeRequestUrl = `preferences/bid-session-mode/update?bidsession_id=${preference.bidSessionId}&staff_id=${preference.staffId}&bidMode=${bidMode}`;

    apiCall(bidModeRequestUrl, 'put', preference)
          .then((response) => {
            dispatch(updateBidModeSuccess(response));
            saveBidMode(bidMode);
          })
          .catch((error) => {
            dispatch(updateBidModeFailure(error));
          });
  };
}

export function updateWeight(preference, newScore, bidMode, prefIds) {
  return () => {
    const baseUrl = `preferences/bids/weight/update/?bidMode=${bidMode}`;
    const url = buildUrlWithAdminImpersonation(baseUrl);
    const data = {
      bidSessionId: preference.bidSessionId,
      staffId: preference.staffId,
      employeeBidId: preference.employeeBidId,
      bidAggregateIds: prefIds,
      bidSessionSnapshotId: preference.bidSessionSnapshotId,
      preferenceOptionId: preference.preferenceOptionId,
      preferenceOptionPropertyId: 0,
      score: newScore,
      bidMode
    };
    return apiCall(url, 'put', data);
  };
}
